import { useMemo, useState } from "react";
import { GeoJSON, Marker, Polyline, Tooltip } from "react-leaflet";
import { divIcon, icon } from "leaflet";

import { Box, Card, Stack, Typography } from "@mui/material";

import { ISurvey } from "Types/survey";

import { useAppSelector } from "Hooks/useRedux";

import useTrafficFleet from "Hooks/useTrafficFleet";
import { renderToStaticMarkup } from "react-dom/server";
import Icon from "Components/Icon";

const ICON_SIZE = 22;

export default function TrafficFleet() {
  const { visible } = useAppSelector((state) => state.trafficFleet);

  const [hoveredItem, setHoveredItem] = useState<ISurvey | null>(null);

  const { data } = useTrafficFleet();

  const markers = useMemo(() => {
    if (!data) return null;

    return data?.map((item: any, indx: number) => {
      if (!item.TTO_Data) return;
      const traffic = JSON.parse(`{${item.TTO_Data}}`);
      const sourceLat = Number(traffic.GeographicalAccident);
      const sourceLng = Number(traffic.GeographicalLength);

      const fleetIconMarkup = renderToStaticMarkup(
        <Box
          style={{
            color: "#000",
            width: "40px",
            height: "40px",
            backgroundColor: "#fff0",
            borderRadius: "50%",
            border: "2px solid",
            borderColor: "#000",
            display: "grid",
            placeItems: "center",
            transform: ` scale(${Math.log2(traffic.TTO + 1)} ,${Math.log2(traffic.TTO + 1)} )`,
          }}
        >
          <Icon icon="directions_car" />
        </Box>
      );

      const fleetIcon = divIcon({
        html: fleetIconMarkup,
        iconSize: [ICON_SIZE, ICON_SIZE],
      });

      const events = {
        mouseover: () => {
          setHoveredItem(item);
        },
        mouseout: () => {
          setHoveredItem(null);
        },
      };

      const tooltipContent = (
        <Tooltip direction="top" offset={[0, -20]}>
          <Card sx={{ py: 2, px: 3 }} className="fa-number">
            <Stack alignItems="center">
              <Stack direction="row" sx={{ width: "100%", justifyContent: "space-between" }}>
                <Typography> {traffic.DeviceName} </Typography>
                <Typography> : نام سامانه </Typography>
              </Stack>
              <Stack direction="row" sx={{ width: "100%", justifyContent: "space-between" }}>
                <Typography>{traffic?.DeviceCode}</Typography>
                <Typography> : کد سامانه</Typography>
              </Stack>
              <Stack direction="row" sx={{ width: "100%", justifyContent: "space-between" }}>
                <Typography>{traffic?.TTO}</Typography>
                <Typography> : تعداد دفعات مشاهده </Typography>
              </Stack>
              <Stack direction="row" sx={{ width: "100%", justifyContent: "space-between" }}>
                <Typography>{traffic?.First}</Typography>
                <Typography> : نخستین مشاهده </Typography>
              </Stack>
              <Stack direction="row" sx={{ width: "100%", justifyContent: "space-between" }}>
                <Typography>{traffic?.Last}</Typography>
                <Typography> : آخرین مشاهده </Typography>
              </Stack>
            </Stack>
          </Card>
        </Tooltip>
      );

      return (
        <>
          <Marker key={`source-${item.id}`} position={[sourceLat, sourceLng]} icon={fleetIcon} eventHandlers={events}>
            {tooltipContent}
          </Marker>
        </>
      );
    });
  }, [data, visible]);

  if (!visible) return <></>;
  return <>{markers}</>;
}
